

















import Vue from 'vue'
import Card from '@/components/Card.vue'
export default Vue.extend({
  components: {
    appCard: Card,
  },
  props: {
    value: Object,
    field: String,
    noField: Boolean,
    hideField: Boolean,
  },
  computed: {
    customItem() {
      const newItem = {} as { [key: string]: string }
      ;['first_name', 'last_name', 'username'].forEach(field => {
        if (this.value[field]) {
          newItem[field] = this.value[field]
        }
      })
      if (this.hideField) {
        return newItem
      }
      if (this.field === 'balance') {
        newItem.USD = Number(this.value.balances.USD).toLocaleString('en-US', {
          minimumFractionDigits: 2,
        })
        newItem.CUP = Number(this.value.balances.CUP).toLocaleString('en-US', {
          minimumFractionDigits: 2,
        })
      } else if (this.field === 'topup_credit') {
        newItem.credit = this.value.topup_credit
      }
      return newItem
    },
  },
})
